import { useMediaQuery, useTheme } from '@mui/material';
const useEventPreviewStyles = (showAll) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    return {
        main: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        eventPreviewContainer: {
            display: 'flex',
            gap: 1,
            width: '100%',
            alignItems: 'center'
        },
        eventPreviewThumbnail: {
            width: 107,
            height: 89,
            borderRadius: 2,
            objectFit: 'cover'
        },
        chipContainer: {
            overflowX: 'auto',
            whiteSpace: 'nowrap',
            display: 'flex',
            maxWidth: '100%',
            gap: 1,
            flexWrap: 'nowrap',
            '& > *': {
                flexShrink: 0
            },
            '&::-webkit-scrollbar': { display: 'none' },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none'
        },
        titleContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5,
            flex: 1,
            minWidth: 0
        },
        titleWithLanguageContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 1,
        },
        timelineContainer: {
            maxHeight: 'calc(100vh - 349px)',
            overflowY: 'auto',
            overflowX: 'hidden',
            // Hide scrollbar by default, show on hover
            '&::-webkit-scrollbar': {
                width: '6px',
                height: '6px'
            },
            '&::-webkit-scrollbar-track': {
                background: 'transparent'
            },
            '&::-webkit-scrollbar-thumb': {
                background: 'transparent',
                borderRadius: '3px'
            },
            '&:hover::-webkit-scrollbar-thumb': {
                background: 'rgba(0, 0, 0, 0.32)'
            },
            // Firefox scrollbar styling
            scrollbarWidth: 'thin',
            scrollbarColor: 'transparent transparent',
            '&:hover': {
                scrollbarColor: 'rgba(0, 0, 0, 0.32) transparent'
            },
            // Hide scrollbar when dropdowns are open
            '&:has(.MuiAutocomplete-popper, .MuiMenu-root, .MuiPopover-root)': {
                '&::-webkit-scrollbar-thumb': {
                    background: 'transparent !important'
                },
                scrollbarColor: 'transparent transparent !important'
            }
        },
        fieldsContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5
        }
    };
};
export default useEventPreviewStyles;
